/**
 * Miroir app de `supabase/functions/_shared/admin-user-delete.ts` — décide
 * d'AFFICHER le bouton « Supprimer ce compte » (le serveur reste seul juge).
 * Garder synchro : parité testée par `_shared/admin-user-delete.test.ts`.
 */

export const PROTECTED_USER_EMAILS = ['app_tester@jeraisonne.fr'];

const TEST_EXAMPLE_DOMAINS = ['example.com', 'example.fr', 'example.org', 'example.net'];

export type DeleteBlockReason = 'self' | 'admin' | 'protected' | 'not_test_account';

export function isDeletableTestEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const e = email.trim().toLowerCase();
  if (PROTECTED_USER_EMAILS.includes(e)) return false;
  const at = e.lastIndexOf('@');
  if (at <= 0) return false;
  const domain = e.slice(at + 1);
  return (
    domain === 'jeraisonne.fr' ||
    domain === 'test' ||
    domain.endsWith('.test') ||
    TEST_EXAMPLE_DOMAINS.includes(domain)
  );
}

export function deleteBlockReason(input: {
  email: string | null | undefined;
  role: string | null | undefined;
  targetId: string;
  actorId: string;
  /**
   * Compte NON CONFIRMÉ (inscription jamais terminée : email non vérifié ou
   * aucun profil — migration 0317) : supprimable même avec une vraie adresse.
   */
  pending?: boolean;
}): DeleteBlockReason | null {
  if (input.targetId === input.actorId) return 'self';
  if (input.role === 'admin') return 'admin';
  const e = (input.email ?? '').trim().toLowerCase();
  if (PROTECTED_USER_EMAILS.includes(e)) return 'protected';
  if (input.pending) return null;
  if (!isDeletableTestEmail(e)) return 'not_test_account';
  return null;
}

/** Explication affichée quand le bouton n'est pas proposé. */
export function deleteBlockLabel(reason: DeleteBlockReason): string {
  switch (reason) {
    case 'self':
      return 'Tu ne peux pas supprimer ton propre compte ici.';
    case 'admin':
      return 'Un compte administrateur ne peut pas être supprimé.';
    case 'protected':
      return 'Compte de revue App Store / Google Play : à conserver.';
    case 'not_test_account':
      return 'Seuls les comptes non confirmés, @jeraisonne.fr ou de test peuvent être supprimés.';
  }
}
